import moment from 'moment'
import 'moment-timezone'

const ZONA_HORARIA = 'America/Cancun'

export default {
  methods: {
    /**
     * Devuelve una fecha en formato ISO 8601 con la zona horaria especificada
     *
     * @param {string} fecha - La fecha en formato 'YYYY-MM-DD'.
     * @param {string} hora - La hora en formato 'HH:mm'.
     * @param {string} zona - La zona horaria en formato de IANA.
     *
     * @returns {string} - La fecha y hora especificadas en el formato ISO 8601 con la zona horaria especificada.
     *
     * @example
     * // returns '2023-05-26T22:30:00-05:00'
     * formatDateZone('2023-05-26', '22:30', 'America/Cancun');
     */
    formatDateZone(fecha, hora, zona) {
      const fechaHora = `${fecha}T${hora}`
      return moment.tz(fechaHora, zona).format()
    },

    calculaPickup(fecha, hora, zona, pickup) {
      const fechaHora = `${fecha}T${hora}`
      // return moment.tz(fechaHora, zona).format()
      return moment.tz(fechaHora, zona).subtract(pickup, 'hours').format()
    },

    formatDate(date) {
      return moment(date).format('MMM-DD')
    },

    formatTime(time) {
      // return moment.utc(time).format('HH:mm')
      return moment.tz(time, ZONA_HORARIA).format('HH:mm')
    },

    /**
     * @description Calcula la fecha maxima seleccionable: un anio posterior al
     * dia en curso en la zona horaria de Cancun.
     *
     * Metodo y no propiedad calculada, por el mismo motivo que fechaHoy (TQO-284)
     *
     * @return {string} fecha en formato 'YYYY-MM-DD'
     */
    maxDateDisp() {
      return moment.tz(ZONA_HORARIA).add(1, 'years').format('YYYY-MM-DD')
    },

    /**
     * @description Devuelve el dia en curso en la zona horaria de Cancun.
     *
     * Es un metodo y no una propiedad calculada a proposito: una computada sin
     * dependencias reactivas se cachea de por vida y una pantalla dejada
     * abierta cruzando la medianoche conservaria el dia anterior (TQO-284)
     *
     * @return {string} fecha en formato 'YYYY-MM-DD'
     */
    fechaHoy() {
      return moment.tz(ZONA_HORARIA).format('YYYY-MM-DD')
    },

    /**
     * @description Calcula la fecha minima seleccionable restando un periodo
     * a la fecha actual en la zona horaria de Cancun.
     *
     * @param {string} time - Periodo a restar: numero + unidad ('d' dias,
     * 'm' meses, 'y' anios). Ej: '1d', '3m', '1y'.
     *
     * @return {string} fecha en formato 'YYYY-MM-DD'
     */
    minDateDisp(time) {
      // La resta se hace con moment y no restando el numero al dia del mes:
      // el dia 1 daba dia 0 y producia una fecha invalida (TQO-273)
      const unidades = { d: 'days', m: 'months', y: 'years' }
      const unidad = unidades[time.slice(-1)] || 'days'
      const valor = parseInt(time.slice(0, -1), 10) || 0

      return moment.tz(ZONA_HORARIA).subtract(valor, unidad).format('YYYY-MM-DD')
    },
  },
}
